// This file is auto-generated by the devtool. Do not edit manually.

import { ISpritesheetMetadata } from './sprite-metadata';
import { AstronautSpritesheets } from './astronaut.config';
import { BatSpritesheets } from './bat.config';
import { BeaverSpritesheets } from './beaver.config';
import { CellSpritesheets } from './cell.config';
import { DemonSpritesheets } from './demon.config';
import { DinoRexSpritesheets } from './dino-rex.config';
import { DragonSpritesheets } from './dragon.config';
import { DragonflySpritesheets } from './dragonfly.config';
import { DuckySpritesheets } from './ducky.config';
import { EffectsSpritesheets } from './effects.config';
import { FiendSpritesheets } from './fiend.config';
import { FrogSpritesheets } from './frog.config';
import { HydraSpritesheets } from './hydra.config';
import { IconsMoreSpritesheets } from './icons-more.config';
import { IconsSpritesheets } from './icons.config';
import { JinnSpritesheets } from './jinn.config';
import { KitsuneSpritesheets } from './kitsune.config';
import { KnightSpritesheets } from './knight.config';
import { LizardSpritesheets } from './lizard.config';
import { LumephonsSpritesheetConfig } from './lumephons.config';
import { MedusaSpritesheets } from './medusa.config';
import { MoleratSpritesheets } from './molerat.config';
import { ParasiteSpritesheets } from './parasite.config';
import { PhoenixlingSpritesheets } from './phoenixling.config';
import { PlaceholdersSpritesheets } from './placeholder.config';
import { RhinoSpritesheets } from './rhino.config';
import { RuneIconsSpritesheets } from './rune-icons.config';
import { ShoebillChickSpritesheets } from './shoebill-chick.config';
import { ShoebillSpritesheets } from './shoebill.config';
import { SmallDragonSpritesheets } from './small-dragon.config';
import { SpiderSpritesheetConfig } from './spider.config';
import { TestSpritesheets } from './test.config';
import { Type200Spritesheets } from './type2-00.config';
import { Type201Spritesheets } from './type2-01.config';
import { Type202Spritesheets } from './type2-02.config';
import { Type203Spritesheets } from './type2-03.config';
import { Type204Spritesheets } from './type2-04.config';
import { Type205Spritesheets } from './type2-05.config';
import { Type206Spritesheets } from './type2-06.config';
import { Type207Spritesheets } from './type2-07.config';
import { Type208Spritesheets } from './type2-08.config';
import { Type209Spritesheets } from './type2-09.config';
import { Type210Spritesheets } from './type2-10.config';
import { WatcherSpritesheets } from './watcher.config';
import { WhisperSpritesheets } from './whisper.config';
import { WormSpritesheets } from './worm.config';

export const AllSpritesheets: ISpritesheetMetadata[] = [
  ...AstronautSpritesheets,
  ...BatSpritesheets,
  ...BeaverSpritesheets,
  ...CellSpritesheets,
  ...DemonSpritesheets,
  ...DinoRexSpritesheets,
  ...DragonSpritesheets,
  ...DragonflySpritesheets,
  ...DuckySpritesheets,
  ...EffectsSpritesheets,
  ...FiendSpritesheets,
  ...FrogSpritesheets,
  ...HydraSpritesheets,
  ...IconsMoreSpritesheets,
  ...IconsSpritesheets,
  ...JinnSpritesheets,
  ...KitsuneSpritesheets,
  ...KnightSpritesheets,
  ...LizardSpritesheets,
  ...LumephonsSpritesheetConfig,
  ...MedusaSpritesheets,
  ...MoleratSpritesheets,
  ...ParasiteSpritesheets,
  ...PhoenixlingSpritesheets,
  ...PlaceholdersSpritesheets,
  ...RhinoSpritesheets,
  ...RuneIconsSpritesheets,
  ...ShoebillChickSpritesheets,
  ...ShoebillSpritesheets,
  ...SmallDragonSpritesheets,
  ...SpiderSpritesheetConfig,
  ...TestSpritesheets,
  ...Type200Spritesheets,
  ...Type201Spritesheets,
  ...Type202Spritesheets,
  ...Type203Spritesheets,
  ...Type204Spritesheets,
  ...Type205Spritesheets,
  ...Type206Spritesheets,
  ...Type207Spritesheets,
  ...Type208Spritesheets,
  ...Type209Spritesheets,
  ...Type210Spritesheets,
  ...WatcherSpritesheets,
  ...WhisperSpritesheets,
  ...WormSpritesheets,
];
